import { PieChartWidget } from './PieChartWidget';
import type { DashboardWidget } from '../../types/panelConfig';

interface Props {
  widget: Extract<DashboardWidget, { type: 'chart-donut' }>;
  sourceId: number | null | undefined;
  parameters?: Record<string, string>;
}

export function DonutChartWidget({ widget, sourceId, parameters }: Props) {
  return <PieChartWidget widget={widget} sourceId={sourceId} variant="donut" parameters={parameters} />;
}
